import React, { useEffect, useRef } from 'react';

const InputFolder = ({ className, value, onChange, maxLength }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <input ref={inputRef} className={className} type="text" value={value} onChange={onChange} autoFocus={true} maxLength={maxLength} />
  );
};

export default InputFolder;
